<template>
  <div class="imprint">
    <div class="hero is-info">
      <div class="hero-body">
        <div class="container has-text-centered">
          <h1 class="title is-2 is-size-3-mobile">Impressum</h1>
          <p class="subtitle is-4 is-size-5-mobile">Angaben gemäß § 5 TMG</p>
        </div>
      </div>
    </div>
    <div class="section is-medium">
      <div class="container is-size-6 is-size-7-mobile">
        <div class="columns">
          <div class="column is-6 is-offset-1">
            <p>
              <strong>Wilde Pracht - Christian Plöhn & Gunnar Plöhn & Birte Schmidt GbR</strong><br />
              Mielberg 4<br />
              24848 Kropp<br /> Deutschland
            </p>
            <p class="smallspacetop">vertretungsberechtigte Gesellschafter: <br />Christian Plöhn, Gunnar Plöhn, Birte Schmidt<br /><br />USt-IdNr.: DE 350 322 217<br />Kleinunternehmer gem&auml;&szlig; &sect; 19 UStG</p>
          </div>
          <div class="column is-">
            <p>
              <strong>Kontakt</strong><br />Telefon: +49 (0) 4624 451 946 3<br />
              E-Mail: moin [at] wilde-pracht.com
            </p>
            <p class="smallspacetop">
              <strong>Presse</strong><br />
              Birte Schmidt<br />
              Telefon: +49 (0) 461 403 060 03<br />
              E-Mail: presse [at] wilde-pracht.com
            </p>
          </div>
        </div>
        <div class="columns">
          <div class="column is-10 is-offset-1">
            <h2 class="has-text-weight-bold smallspacetop">
              Verbraucher&shy;streit&shy;beilegung/Universal&shy;schlichtungs&shy;stelle
            </h2>
            <p>
              Die Europäische Kommission stellt eine Plattform zur
              Online-Streitbeilegung (OS) bereit, die Sie hier finden
              <a href="https://ec.europa.eu/consumers/odr/" target="_blank"
                >https://ec.europa.eu/consumers/odr/</a
              >. Zur Teilnahme an einem Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle sind wir nicht verpflichtet und
              nicht bereit.
            </p>
            <p class="smallspacetop">
              <i
                ><a
                  target="_blank"
                  title="Impressum"
                  href="https://shop.trustedshops.com/de/rechtstexte/"
                  >Impressum</a
                >
                erstellt mit dem
                <a
                  target="_blank"
                  title="Trusted Shops"
                  href="https://shop.trustedshops.com/de/"
                  >Trusted Shops</a
                >
                Rechtstexter in Kooperation mit
                <a
                  target="_blank"
                  title="FÖHLISCH Rechtsanwälte"
                  href="https://foehlisch.com"
                  rel="nofollow"
                  >FÖHLISCH Rechtsanwälte</a
                >.</i
              >
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Impressum",
  metaInfo: {
    title: "Impressum | Wilde Pracht",
    meta: [
      {
        name: "description",
        content:
          "Du willst wissen wer hinter dem Angebot steht? Dann findest du hier die Antwort."
      },
      { itemprop: "name", content: "Impressum | Wilde Pracht" },
      { property: "og:title", content: "Impressum | Wilde Pracht" },
      {
        itemprop: "description",
        content:
          "Du willst wissen wer hinter dem Angebot steht? Dann findest du hier die Antwort."
      },
      {
        property: "og:description",
        content:
          "Du willst wissen wer hinter dem Angebot steht? Dann findest du hier die Antwort."
      },
      {
        name: "robots",
        content: "noindex"
      }
    ]
  }
};
</script>
